import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { Image } from '@sainsburys-tech/bolt';
import * as Styled from '../../Footer.styles';
var imgPath = '//documents.4rgos.it/v1/static';

var Brands = function Brands(_ref) {
  var _ref$nativeLazy = _ref.nativeLazy,
      nativeLazy = _ref$nativeLazy === void 0 ? false : _ref$nativeLazy,
      brands = _ref.brands;
  return /*#__PURE__*/React.createElement(Styled.Brand, {
    className: "xs-block xs-12--none",
    "data-test": "component-app"
  }, /*#__PURE__*/React.createElement(Styled.BrandWrapper, null, brands.map(function (brand, index) {
    return /*#__PURE__*/React.createElement(Styled.BrandRow, {
      key: index
    }, brand.map(function (_ref2) {
      var name = _ref2.name,
          dataTest = _ref2.dataTest,
          linkAttributes = _ref2.linkAttributes;
      return /*#__PURE__*/React.createElement(Styled.BrandImage, _extends({
        key: name,
        brand: name,
        "data-test": dataTest
      }, linkAttributes, {
        "aria-label": name
      }), /*#__PURE__*/React.createElement(Image, {
        alt: name,
        src: "".concat(imgPath, "/").concat(name, "-logo"),
        lazy: true,
        nativeLazy: nativeLazy,
        lazyWrapElement: "span"
      }));
    }));
  })));
};

Brands.propTypes = {
  nativeLazy: PropTypes.bool,
  brands: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    dataTest: PropTypes.string.isRequired,
    linkAttributes: PropTypes.shape({
      href: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired
    })
  })).isRequired).isRequired
};
export default Brands;